/*
 *   File : manage-nominee.js
 *   Author : https://evoqins.com
 *   Description : Manage nominee modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { differenceInYears } from 'date-fns';
import { toast } from "react-toastify";

//custom component
import { OTPInput, RadioGroup } from '../Form-Elements';
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { NomineeCard } from '../Cards';
import { useSelector } from 'react-redux';
import { _formatDateFormat, _getOTP, _getProfile } from '../../Helper';
import { APIService } from '../../Service';

// Assets
// import Loader from "../../Assets/Images/coloured_loader.svg";
import Delete from "../../Assets/Images/KYC/delete.svg";

// Custom data
const NOMINEE = [
    {
        id: 1,
        display_name: "Yes"
    },
    {
        id: 2,
        display_name: "No"
    },
];

const ManageNomineeModal = (props) => {

    //get general data from redux
    const GENERAL_DATA = useSelector((store) => store.Reducer.GENERAL_DATA);
    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA); // name it
    const PROGRESS_DATA = useSelector((store) => store.Reducer.SIGNUP_PROGRESS_DATA);
    const otpInputRef = useRef(null);

    const [optInNominee, setOptInNominee] = useState(2);
    const [tabIndex, setTabIndex] = useState(1);
    const [toggleNominee, setToggleNominee] = useState(false);

    // OTP
    const [focusedInput, setFocusedInput] = useState(2);
    const [otpValue, setOtpValue] = useState("");
    const [otpError, setOtpError] = useState("");
    const [timer, setTimer] = useState(30);
    const [loading, setLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [disableResendOTP, setDisableResendOTP] = useState(false); // for Resend OTP

    const [nomineeData, setNomineeData] = useState([]);
    // const [loadNomineeStatus, setLoadNomineeStatus] = useState(false);

    const [errorMessage, setErrorMessage] = useState([
        {
            "id": crypto.randomUUID(),
            "name_error": null,
            "relation_id_error": null,
            "dob_error": null,
            "allocation_error": null,

            "id_proof_no_error": null,
            "selected_proof_id_error": null,
            "mobile_number_error": null,
            "email_error": null,

            "guardian_name_error": null,
            "guardian_relationship_id_error": null,
            // "guardian_pan_error": null,


            "nationality_error": null,
            "address_error": null,
            "state_error": null,
            "city_error": null,
            "pincode_error": null
        }
    ]);

    const [countryData, setCountryData] = useState([]);
    const [nomineeVisibility, setNomineeVisibility] = useState(GENERAL_DATA?.nominations_info_visibility[0]?.id);

    useEffect(() => {
        let nominee_errors = [];
        if (PROGRESS_DATA?.kyc_data?.nominee?.length !== 0) {

            let nominee_list = PROGRESS_DATA.kyc_data?.nominee.map((nominee) => (
                {
                    ...nominee,
                    "id": nominee.nominee_id || crypto.randomUUID()
                }
            ))
            setNomineeData(nominee_list);


            for (let nominee_count = 0; nominee_count < PROGRESS_DATA?.kyc_data?.nominee?.length; nominee_count++) {
                let nominee_error = {
                    "name_error": null,
                    "relation_id_error": null,
                    "dob_error": null,
                    "allocation_error": null,

                    "id_proof_no_error": null,
                    "selected_proof_id_error": null,
                    "mobile_number_error": null,
                    "email_error": null,

                    "guardian_name_error": null,
                    "guardian_relationship_id_error": null,
                    "guardian_id_no_error": null,
                    "guardian_mobile_number_error": null,
                    "guardian_email_error": null,
                    "guardian_id_type_error": null,

                    "nationality_error": null,
                    "address_error": null,
                    "state_error": null,
                    "city_error": null,
                    "pincode_error": null

                };
                nominee_errors.push(nominee_error);
            }

            if (PROGRESS_DATA?.kyc_data?.nominee[0]?.nominations_info_visibility) {
                setNomineeVisibility(PROGRESS_DATA?.kyc_data?.nominee[0]?.nominations_info_visibility);
            }

        } else {
            nominee_errors.push({
                "id": crypto.randomUUID(),
                "name_error": null,
                "relation_id_error": null,
                "dob_error": null,
                "allocation_error": null,

                "id_proof_no_error": null,
                "selected_proof_id_error": null,
                "mobile_number_error": null,
                "email_error": null,

                "guardian_name_error": null,
                "guardian_relationship_id_error": null,
                "guardian_id_no_error": null,
                "guardian_mobile_number_error": null,
                "guardian_email_error": null,
                "guardian_id_type_error": null,

                "nationality_error": null,
                "address_error": null,
                "state_error": null,
                "city_error": null,
                "pincode_error": null

            });
            let nominees = [{
                "id": crypto.randomUUID(),
                "nominee_id": null,
                "name": null,
                "relation_id": null,
                "relation": null,
                "dob": null,
                "allocation": null,
                "guardian_name": null,
                "guardian_relationship_id": null,
                "guardian_relationship": null,
                "guardian_id_proof_type": null,
                "guardian_id_proof_number": null,
                "guardian_address": {
                    "address_line1": null,
                    "state_id": null,
                    "state_name": null,
                    "city_id": null,
                    "city": null,
                    "pincode": null,
                    "country_id": null,
                    "country": null
                },
                "guardian_contact_detail": {
                    "email": null,
                    "country_code": null,
                    "phone_number": null
                },
                "identity_proof_type": null,
                "identity_proof_number": null,
                "nominee_address": {
                    "address_line1": null,
                    "state_id": null,
                    "state_name": null,
                    "city_id": null,
                    "city": null,
                    "pincode": null,
                    "country_id": null,
                    "country": null,
                },
                "contact_detail": {
                    "email": null,
                    "country_code": null,
                    "phone_number": null
                },
                "nominations_info_visibility": true,
            }]
            setNomineeData(nominees)
        }
        // setAddNomineeSelect(1);
        setErrorMessage(nominee_errors);
    }, [PROGRESS_DATA]);

    useEffect(() => {
        // _getNomineeData();
        _getCountry();
    }, []);

    //for otp timer
    useEffect(() => {
        if (toggleNominee === true && timer > 0) {
            // Start the timer when requestOtpSuccess becomes true
            const countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
            // Clear the timer when the component unmounts or when the timer reaches 0
            return () => {
                clearInterval(countdown);
            };
        }
    }, [toggleNominee, timer]);

    useEffect(() => {
        if (nomineeData?.length !== 0) {
            setOptInNominee(1);
        } else {
            setOptInNominee(2);
        }
    }, [nomineeData]);

    //handle nominee select
    const _handleAddNominee = (id) => {
        setOptInNominee(id);
    };

    const _handleAddMoreNominee = () => {

        if (nomineeData.length !== 3) {
            // Create a new nominee with default values
            const new_nominee = {
                "id": crypto.randomUUID(),
                "nominee_id": null,
                "name": null,
                "relation_id": null,
                "relation": null,
                "dob": null,
                "allocation": null,
                "guardian_name": null,
                "guardian_relationship_id": null,
                "guardian_relationship": null,
                "guardian_id_proof_type": null,
                "guardian_id_proof_number": null,
                "guardian_address": {
                    "address_line1": null,
                    "state_id": null,
                    "state_name": null,
                    "city_id": null,
                    "city": null,
                    "pincode": null,
                    "country_id": null,
                    "country": null
                },
                "guardian_contact_detail": {
                    "email": null,
                    "country_code": null,
                    "phone_number": null
                },
                "identity_proof_type": null,
                "identity_proof_number": null,
                "nominee_address": {
                    "address_line1": null,
                    "state_id": null,
                    "state_name": null,
                    "city_id": null,
                    "city": null,
                    "pincode": null,
                    "country_id": null,
                    "country": null,
                },
                "contact_detail": {
                    "email": null,
                    "country_code": null,
                    "phone_number": null
                },
                "nominations_info_visibility": true,
            };

            // Update the nomineeData array with the new nominee
            setNomineeData((prevNomineeData) => [...prevNomineeData, new_nominee]);

            const new_error = {
                "id": crypto.randomUUID(),
                "name_error": null,
                "relation_id_error": null,
                "dob_error": null,
                "allocation_error": null,

                "id_proof_no_error": null,
                "selected_proof_id_error": null,
                "mobile_number_error": null,
                "email_error": null,

                "guardian_name_error": null,
                "guardian_relationship_id_error": null,

                "nationality_error": null,
                "address_error": null,
                "state_error": null,
                "city_error": null,
                "pincode_error": null

            };

            setErrorMessage([...errorMessage, new_error]);

            // To avoid modal flickering 
            setTimeout(() => {
                setTabIndex(nomineeData.length + 1);
            }, 100);
        }
    };

    // remove nominee from list
    const _handleRemoveNominee = () => {


        let nominee_data = nomineeData.filter((_, key) => key !== tabIndex - 1);
        setNomineeData([...nominee_data]);

        if (tabIndex !== 1) {
            setTabIndex(index => index - 1);
        };

    };

    //validating input field 
    const _validateNomineeData = (nominees) => {

        // Setting err array to scroll to first err input
        let error_inputs = [];
        let is_minor_nominee = false;
        let error_list = [...errorMessage];
        let validation_status = true;
        let tab_index = tabIndex;
        let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
        let validate_pan = /^[A-Z]{3}P[A-Z]{1}\d{4}[A-Z]{1}$/; // validation of PAN

        for (let i = 0; i < nominees.length; i++) {

            let nominee_data = nominees[i];
            let selected_id_proof_id = nominee_data.identity_proof_type;
            let selected_guardian_id_proof_id = nominee_data.guardian_id_proof_type;

            if (nominee_data?.dob != null) {
                is_minor_nominee = differenceInYears(new Date(), _formatDateFormat(nominee_data?.dob)) < 18;
            } else {
                is_minor_nominee = false;
            }

            if (nominee_data.name === null) {
                error_list[i].name_error = "Provide the nominee full name";
                validation_status = false;
                error_inputs.push(`name-${i}`);
            } else {
                error_list[i].name_error = null;
            }

            if (nominee_data.relation_id === null) {
                error_list[i].relation_id_error = 'Please declare the relationship with the nominee';
                validation_status = false;
                error_inputs.push(`relation-${i}`);
            } else {
                error_list[i].relation_id_error = '';
            }

            // nominee_data.allocation = number or empty string
            if (nominee_data.allocation === null) {
                error_list[i].allocation_error = 'Please specify the allocation details';
                validation_status = false;
                error_inputs.push(`allocation-${i}`);
            } else {
                error_list[i].allocation_error = '';
            }

            if (nominee_data.dob === null) {
                error_list[i].dob_error = "Please provide the nominee's date of birth";
                validation_status = false;
                error_inputs.push(`dob-${i}`);
            } else {
                error_list[i].dob_error = '';
            }


            if (is_minor_nominee == false) {

                if (nominee_data.identity_proof_type === null) {
                    error_list[i].selected_proof_id_error = "Please provide the proof no";
                    validation_status = false;
                    error_inputs.push(`id-proof-type-${i}`);
                } else {
                    error_list[i].selected_proof_id_error = '';
                }

                if (nominee_data.identity_proof_number === null) {
                    error_list[i].id_proof_no_error = "Please provide ID proof number";
                    validation_status = false;
                    error_inputs.push(`id-proof-number-${i}`);
                } else if (nominee_data.identity_proof_type === "pan" && !validate_pan.test(nominee_data.identity_proof_number)) { // Pan Validation
                    error_list[i].id_proof_no_error = 'Please provide valid PAN ID';
                    validation_status = false;
                    error_inputs.push(`id-proof-number-${i}`);
                } else if (nominee_data.identity_proof_type === "aadhaar" && nominee_data.identity_proof_number.length < 4) { // Aadhaar Validation
                    error_list[i].id_proof_no_error = 'Please provide last 4 digit of Aadhaar';
                    validation_status = false;
                    error_inputs.push(`id-proof-number-${i}`);
                } else {
                    error_list[i].id_proof_no_error = '';
                }

            }

            //guardian validation
            if (is_minor_nominee === true) {
                if (nominee_data.guardian_name === null) {
                    error_list[i].guardian_name_error = "Please provide the guardian's full name in this field";
                    validation_status = false;
                    error_inputs.push(`guardian-name-${i}`);
                } else {
                    error_list[i].guardian_name_error = '';
                }

                if (nominee_data.guardian_relationship_id == null) {
                    error_list[i].guardian_relationship_id_error = 'Please select the relationship with the nominee from the list';
                    validation_status = false;
                    error_inputs.push(`guardian-relation-${i}`);
                } else {
                    error_list[i].guardian_relationship_id_error = '';
                }

                if (nominee_data.guardian_id_proof_type == null) {
                    error_list[i].guardian_id_type_error = 'Please select the ID proof';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-type-${i}`);
                } else {
                    error_list[i].guardian_id_type_error = '';
                }


                if (nominee_data.guardian_id_proof_number == null) {
                    error_list[i].guardian_id_no_error = 'Please provide the ID proof no';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-number-${i}`);
                    // 
                } else if (nominee_data.guardian_id_proof_type === "pan" && !validate_pan.test(nominee_data.guardian_id_proof_number)) {  // Pan Validation
                    error_list[i].guardian_id_no_error = 'Please provide valid PAN ID';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-number-${i}`);
                } else if (nominee_data.guardian_id_proof_type === "aadhaar" && nominee_data.guardian_id_proof_number.length < 4) {  // Aadhaar Validation
                    error_list[i].guardian_id_no_error = 'Please provide last 4 digit of Aadhaar';
                    validation_status = false;
                    error_inputs.push(`guardian-id-proof-number-${i}`);
                } else {
                    error_list[i].guardian_id_no_error = '';
                }


                if (nominee_data.guardian_contact_detail.phone_number === null) {
                    error_list[i].guardian_mobile_number_error = "Please provide mobile number";
                    validation_status = false;
                    error_inputs.push(`guardian-phone-number-${i}`);
                } else if (nominee_data.guardian_contact_detail.country_code === "+91" && nominee_data.guardian_contact_detail.phone_number.length !== 10) {
                    error_list[i].guardian_mobile_number_error = "Please provide valid mobile number";
                    validation_status = false;
                    error_inputs.push(`guardian-phone-number-${i}`);
                } else {
                    error_list[i].guardian_mobile_number_error = '';
                }


                if (nominee_data.guardian_contact_detail.email == null) {
                    error_list[i].guardian_email_error = "Please provide email";
                    validation_status = false;
                    error_inputs.push(`gurdian-email-${i}`);
                } else if (!validate_email.test(nominee_data.guardian_contact_detail.email)) {
                    error_list[i].guardian_email_error = "Please provide valid email";
                    validation_status = false;
                    error_inputs.push(`gurdian-email-${i}`);
                } else {
                    error_list[i].guardian_email_error = "";
                }

                if (nominee_data.guardian_address.country === null) {
                    error_list[i].nationality_error = "Please provide country";
                    validation_status = false;
                    error_inputs.push(`nationality-${i}`);
                } else {
                    error_list[i].nationality_error = "";
                }

                if (nominee_data.guardian_address.address_line1 === null) {
                    error_list[i].address_error = "Please provide address";
                    validation_status = false;
                    error_inputs.push(`address-${i}`);
                } else {
                    error_list[i].address_error = "";
                }

                if (nominee_data.guardian_address.state_name === null) {
                    error_list[i].state_error = "Please select state";
                    validation_status = false;
                    error_inputs.push(`state-${i}`);
                } else {
                    error_list[i].state_error = "";
                }

                if (nominee_data.guardian_address.city === null) {
                    error_list[i].city_error = "Please select city";
                    validation_status = false;
                    error_inputs.push(`city-${i}`);
                } else {
                    error_list[i].city_error = "";
                }

                if (nominee_data.guardian_address.pincode === null) {
                    error_list[i].pincode_error = "Please provide pincode";
                    validation_status = false;
                    error_inputs.push(`pincode-${i}`);
                } else {
                    error_list[i].pincode_error = "";
                }
            }

            if (is_minor_nominee === false) {
                if (nominee_data.contact_detail.phone_number === null) {
                    error_list[i].mobile_number_error = "Please provide mobile number";
                    validation_status = false;
                    error_inputs.push(`phone-number-${i}`);
                } else if (nominee_data.contact_detail.country_code === "+91" && nominee_data.contact_detail.phone_number.length !== 10) {
                    error_list[i].mobile_number_error = "Please provide valid mobile number";
                    validation_status = false;
                    error_inputs.push(`phone-number-${i}`);
                } else {
                    error_list[i].mobile_number_error = '';
                }

                if (nominee_data.contact_detail.email === null) {
                    error_list[i].email_error = "Please provide email ID";
                    validation_status = false;
                    error_inputs.push(`email-${i}`);
                } else if (!validate_email.test(nominee_data.contact_detail.email)) {
                    error_list[i].email_error = "Please provide valid email ID";
                    validation_status = false;
                    error_inputs.push(`email-${i}`);
                } else {
                    error_list[i].email_error = '';
                }

                // Address
                if (nominee_data.nominee_address.country === null) {
                    error_list[i].nationality_error = "Please provide country";
                    validation_status = false;
                    error_inputs.push(`nationality-${i}`);
                } else {
                    error_list[i].nationality_error = "";
                }

                if (nominee_data.nominee_address.address_line1 === null) {
                    error_list[i].address_error = "Please provide address";
                    validation_status = false;
                    error_inputs.push(`address-${i}`);
                } else {
                    error_list[i].address_error = "";
                }

                if (nominee_data.nominee_address.state_name === null) {
                    error_list[i].state_error = "Please select state";
                    validation_status = false;
                    error_inputs.push(`state-${i}`);
                } else {
                    error_list[i].state_error = "";
                }

                if (nominee_data.nominee_address.city === null) {
                    error_list[i].city_error = "Please select city";
                    validation_status = false;
                    error_inputs.push(`city-${i}`);
                } else {
                    error_list[i].city_error = "";
                }

                if (nominee_data.nominee_address.pincode === null) {
                    error_list[i].pincode_error = "Please provide pincode";
                    validation_status = false;
                    error_inputs.push(`pincode-${i}`);
                } else {
                    error_list[i].pincode_error = "";
                }
            }
        }

        setErrorMessage([...error_list]);
        setTabIndex(() => tab_index);


        // Scrolling to first error
        if (error_inputs.length !== 0) {
            let first_err_id = error_inputs[0];
            let error_tab = Number(first_err_id.slice(-1)) + 1;

            // Setting first error element tab and scrolling to it
            setTabIndex(error_tab);
            setTimeout(() => {
                let element = document.getElementById(first_err_id);
                element.scrollIntoView({ behavior: "smooth" });
            }, 200);

        };

        return validation_status;
    };

    //handle save nominee data
    const _handleSaveNominee = () => {
        // Validate UI input fields
        if (optInNominee === 2) {
            setLoading(true);
            _sendOTP();
        } else {
            const is_valid = _validateNomineeData(nomineeData);
            if (is_valid) {
                setLoading(true);
                _sendOTP();
            } else {
                // console.log(errorMessage);
                // console.log(nomineeData);
            }
        };
    };

    //handle tab change
    const _handleTabChange = (id) => {
        setTabIndex(id);
    };

    //handle confirm otp
    const _handleChangeOTP = (value) => {
        setOtpValue(value);
        setOtpError("");
    };

    // Function to handle OTP digit input for a specific position
    const _handleResendOTP = () => {
        setDisableResendOTP(true);
        // API call for resending otp
        let resend = true;
        _sendOTP(resend);
    };

    //handle back
    const _handleBack = () => {
        if (isDisabled) return;
        setToggleNominee(false);
        setOtpValue("");
        setLoading(false);
        setIsDisabled(false);
        otpInputRef.current.disabled = false;
    };

    const _handleNomineeSubmit = () => {

        if (otpValue.length === 0) {
            setOtpError("Please enter the OTP");
            return;
        } else if (otpValue.length !== 4) {
            setOtpError("Please enter the full OTP");
            return;
        };


        setLoading(true);
        setIsDisabled(true);
        if (optInNominee === 2) {
            _addNominee([]);
        } else {
            _addNominee(nomineeData);
        };
    };

    //handle nominee select
    const _handleChangeNomineeVisibility = (id) => {
        setNomineeVisibility(id);
    };

    // Update Nominee data
    const _handleOnChangeInput = (val, nominee_index, type, is_minor) => {
        let updated_nominees = nomineeData.map((data, key) => {
            if (nominee_index === key) {
                // updating err msg on change
                let error_list = errorMessage.map(((err, i) => {
                    if (nominee_index == i) {
                        return { ...err, [`${type}_error`]: "" }
                    } else {
                        return err;
                    }
                }))

                setErrorMessage(error_list);

                if (type === "relation_id") {
                    return { ...data, [type]: val.id, ["relation"]: val.name };
                } else if (type === "guardian_relationship_id") {
                    return { ...data, [type]: val.id, ["guardian_relationship"]: val.name };
                } else if (type === "selected_proof_id") {
                    return { ...data, ["identity_proof_type"]: val.id, ["identity_proof_number"]: null };
                } else if (type === "guardian_id_proof_type") {
                    return { ...data, [type]: val.id, ["guardian_id_proof_number"]: null };
                } else if (type === "id_proof_no") {
                    return { ...data, ["identity_proof_number"]: val };
                } else if (type === "mobile_number") {
                    return {
                        ...data,
                        ["contact_detail"]: {
                            "email": data.contact_detail.email,
                            "country_code": val.country_code,
                            "phone_number": val.phone_number
                        }
                    };
                } else if (type === "email") {
                    return {
                        ...data,
                        ["contact_detail"]: {
                            ...data.contact_detail,
                            "email": val,
                        }
                    };
                } else if (type === "guardian_mobile_number") {
                    return {
                        ...data,
                        ["guardian_contact_detail"]: {
                            "email": data.guardian_contact_detail.email,
                            "country_code": val.country_code,
                            "phone_number": val.phone_number
                        }
                    };
                } else if (type === "guardian_email") {
                    return {
                        ...data,
                        ["guardian_contact_detail"]: {
                            ...data.guardian_contact_detail,
                            "email": val,
                        }
                    };
                } else if (type === "nationality") {
                    return {
                        ...data,
                        ["nominee_address"]: {
                            ...data.nominee_address,
                            "country_id": val.id,
                            "country": val.name,
                            "state_id": null,
                            "state_name": null,
                            "city": null,
                            "city_id": null,
                        }
                    };
                } else if (type === "address") {
                    return {
                        ...data,
                        ["nominee_address"]: {
                            ...data.nominee_address,
                            "address_line1": val,
                        }
                    };
                } else if (type === "state") {
                    return {
                        ...data,
                        ["nominee_address"]: {
                            ...data.nominee_address,
                            "state_id": val.id,
                            "state_name": val.name,
                            "city": null,
                            "city_id": null,
                        }
                    };
                } else if (type === "city") {
                    return {
                        ...data,
                        ["nominee_address"]: {
                            ...data.nominee_address,
                            "city": val.name,
                            "city_id": val.id,
                        }
                    };
                } else if (type === "pincode") {
                    return {
                        ...data,
                        ["nominee_address"]: {
                            ...data.nominee_address,
                            "pincode": val,
                        }
                    };
                } else if (type === "guardian_nationality") {
                    return {
                        ...data,
                        ["guardian_address"]: {
                            ...data.guardian_address,
                            "country_id": val.id,
                            "country": val.name,
                            "state_id": null,
                            "state_name": null,
                            "city": null,
                            "city_id": null,
                        }
                    };
                } else if (type === "guardian_address") {
                    return {
                        ...data,
                        ["guardian_address"]: {
                            ...data.guardian_address,
                            "address_line1": val,
                        }
                    };
                } else if (type === "guardian_state") {
                    return {
                        ...data,
                        ["guardian_address"]: {
                            ...data.guardian_address,
                            "state_id": val.id,
                            "state_name": val.name,
                            "city": null,
                            "city_id": null,
                        }
                    };
                } else if (type === "guardian_city") {
                    return {
                        ...data,
                        ["guardian_address"]: {
                            ...data.guardian_address,
                            "city": val.name,
                            "city_id": val.id,
                        }
                    };
                } else if (type === "guardian_pincode") {
                    return {
                        ...data,
                        ["guardian_address"]: {
                            ...data.guardian_address,
                            "pincode": val,
                        }
                    };
                } else if (type === "guardian_relationship_name") {
                    return {
                        ...data, [type]: val.display_name, ["guardian_relationship_id"]: val.id
                    };
                } else if (type === "dob") {

                    if (is_minor) {
                        return {
                            ...data,
                            "dob": val || null,
                            "identity_proof_type": null,
                            "identity_proof_number": null,
                            "contact_detail": {
                                "email": null,
                                "country_code": null,
                                "phone_number": null
                            },
                        };
                    } else {
                        return {
                            ...data,
                            "dob": val || null,
                            "guardian_id_proof_type": null,
                            "guardian_id_proof_number": null,
                            "guardian_contact_detail": {
                                "email": null,
                                "country_code": null,
                                "phone_number": null
                            },
                        };
                    }

                } else {
                    return { ...data, [type]: val };
                };
            };
            return data;
        });

        setNomineeData([...updated_nominees]);

    };

    // API - send OTP 
    const _sendOTP = (resend) => {

        // API CALL from helper function
        const param = {
            type: "Nominee"
        };

        _getOTP(param).then(response => {
            if (response.status_code === 200) {

                setOtpValue("");
                setTimer(30);
                setFocusedInput(2);
                setOtpError("");

                if (resend === true) {
                    toast.dismiss();
                    let message_medium = USER_DATA.phone.country_code == "+91" ? " mobile" : " email"
                    toast.success(`OTP sent successfully to registered ${message_medium}`, {
                        className: "e-toast",
                    });
                } else {
                    setToggleNominee(true);
                };

            } else {
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",

                });
            };
            setLoading(false);
            setDisableResendOTP(false);
        })
    };

    //API- Add nominee
    const _addNominee = (nominees) => {

        let is_post = true;
        let url = 'profile/upsert-nominee ';
        let data = {
            "nominee": nominees,
            "is_nominee_available": optInNominee === 1 ? true : false,
            "nominations_info_visibility": nomineeVisibility,
            "otp": otpValue
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                const button = document.querySelector("#close-nominee-modal");
                button.click();
                toast.dismiss();
                toast.success("Nominees updated successfully", {
                    className: "e-toast",

                });
                props.onClose("SUCCESS");
            } else {
                setToggleNominee(false);
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",

                });
            }
            setLoading(false);
            setIsDisabled(false);
        });
    };

    //API- Get countries
    const _getCountry = () => {
        let is_post = false;
        let url = 'general/countries';
        let data = null;

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setCountryData(response.data);
            } else {
                setCountryData([]);
            }
        });
    };

    return (
        <div className="modal fade e-manage-modal"
            id="manage-nominee-modal"
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="manageNomineeModalLabel"
            aria-hidden="true">
            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable ${toggleNominee ? "" : "modal-lg"} `}>
                {
                    toggleNominee === false ? (
                        <div className="modal-content e-bg-lotion e-border-radius-24 e-modal-box-shadow">
                            <div className="modal-header justify-content-space-between pt-4 px-3 px-sm-4 pb-3 border-0">
                                <h6 className='mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px'>
                                    Add nominee
                                </h6>

                                <img src={require("../../Assets/Images/close-btn.svg").default}
                                    id='close-nominee-modal'
                                    draggable={false}
                                    className='cursor-pointer'
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    alt='close'
                                    onClick={props.onClose} />
                            </div>
                            <div className="d-flex flex-column modal-body pb-4 px-3 px-sm-4 pt-0">
                                <div className='e-border-radius-16 e-bg-cornsilk padding-12px-all'>
                                    <div className='d-flex gap-0-8 align-items-center'>
                                        <img src={require("../../Assets/Images/Profile/hint.svg").default}
                                            draggable={false}
                                            alt='hint' />
                                        <p className='mb-0 e-text-ochre e-font-12 e-alt-font-poppins e-font-weight-400 line-height-16px letter-spacing-3' >
                                            Adding a nominee ensures your chosen person will receive your assets, simplifying the transfer process when needed
                                        </p>
                                    </div>
                                </div>

                                <div className='pt-3'>
                                    <p className='mb-2 e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px'>
                                        Add a nominee to your investment account?
                                    </p>

                                    <div className='d-flex e-gap-0-16'>
                                        <RadioGroup data={NOMINEE}
                                            selected={optInNominee}
                                            handleSelect={_handleAddNominee} />
                                    </div>
                                </div>


                                {/* Nominee Inputs */}
                                {
                                    optInNominee === 1 &&
                                    <div className='row mt-4 pt-1 position-relative'>
                                        {
                                            nomineeData.map((nominee, key) => (
                                                <React.Fragment key={nominee.id}>

                                                    {/* Nominee tabs */}
                                                    <div className={`order-${key + 1} col-auto pe-0 pe-sm-2  d-flex`}>
                                                        <p className={`${tabIndex === key + 1 ? 'e-text-egyptian-blue e-border-tab-active' : 'e-text-dark-liver cursor-pointer'} e-font-14-res text-nowrap mb-0 e-font-16 e-alt-font-poppins e-font-weight-600 line-height-14px`}
                                                            onClick={() => _handleTabChange(key + 1)}>
                                                            {`Nominee ${key + 1}`}
                                                        </p>

                                                        {
                                                            tabIndex !== 3 && key == 0 && nomineeData.length < 3 &&
                                                            <p className='e-font-14-res position-absolute end-0 me-3 text-nowrap cursor-pointer mb-0 e-text-indigo e-font-16 e-alt-font-poppins e-font-weight-500 line-height-14px'
                                                                onClick={_handleAddMoreNominee} >
                                                                + Add new
                                                            </p>
                                                        }
                                                    </div>

                                                    {/* Nominee delete icon */}
                                                    {
                                                        tabIndex !== 1 && key == 0 &&
                                                        <div className={`mt-2 order-4 text-end`}>
                                                            <img src={Delete}
                                                                width={30}
                                                                height={30}
                                                                draggable={false}
                                                                className={'cursor-pointer object-fit-contain'}
                                                                alt='delete'
                                                                onClick={() => _handleRemoveNominee()} />
                                                        </div>
                                                    }

                                                    <div className={`${tabIndex === 1 && "mt-4 pt-3"} ${tabIndex === key + 1 ? "" : "d-none"} order-5 px-3`}>
                                                        <NomineeCard
                                                            type={2}
                                                            data={GENERAL_DATA}
                                                            index={key}
                                                            countryData={countryData}
                                                            nomineeData={nominee}
                                                            error={errorMessage[key]}
                                                            onChange={_handleOnChangeInput}
                                                        />
                                                    </div>

                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                }

                                {/* nominee visibility */}
                                {
                                    optInNominee === 1 ?
                                        <div className='mt-3'>
                                            <h6 className='mb-2 e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px'>
                                                Nominee visibility on account statement*
                                            </h6>
                                            <div className='d-flex e-gap-0-16'>
                                                <RadioGroup data={GENERAL_DATA.nominations_info_visibility}
                                                    selected={nomineeVisibility}
                                                    handleSelect={_handleChangeNomineeVisibility} />
                                            </div>
                                        </div>
                                        :
                                        null
                                }


                                <div className="d-flex justify-content-between gap-3 align-items-center mt-5">
                                    <SecondaryButton name={"Cancel"}
                                        dismiss="modal"
                                        className="w-50 padding-12px-top padding-12px-bottom e-bg-lotion e-font-16 e-text-charleston-green e-border-bright-gray"
                                        onPress={props.onClose} />

                                    <PrimaryButton name={"Save & Continue"}
                                        loading={loading}
                                        disabled={loading}
                                        className="w-50 e-border-radius-32 padding-12px-top padding-12px-bottom "
                                        onPress={_handleSaveNominee} />
                                </div>

                            </div>
                        </div>
                    ) : (
                        <div className="modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow">
                            <div className="modal-header justify-content-start e-gap-0-16 pt-4 pb-3 px-3 px-sm-4 border-0">

                                {/* Hidden close btn for closing modal */}
                                <span id='close-nominee-modal'
                                    data-bs-dismiss="modal"
                                    className='visually-hidden'
                                    aria-label="close"
                                    alt='close btn'
                                />
                                <img src={require("../../Assets/Images/Login/back-icon.svg").default}
                                    draggable={false}
                                    className='cursor-pointer'
                                    alt="arrow-back"
                                    onClick={_handleBack} />
                                <h6 className='mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px'>
                                    Enter OTP
                                </h6>

                            </div>
                            <div className="modal-body pb-4 px-3 px-sm-4 pt-0">

                                {/* otp section */}
                                <div className='p-3 e-border-radius-16 e-bg-cultured'>
                                    {
                                        USER_DATA.phone.country_code == "+91" ?
                                            <p className='mb-0 pt-3 e-text-onyx e-font-16 e-alt-font-poppins e-font-weight-400 line-height-28px'>
                                                An OTP has been sent to your registered mobile number.
                                                <span className='ms-1 e-text-egyptian-blue e-font-weight-500'>
                                                    {USER_DATA.phone.country_code} {USER_DATA.phone.number}
                                                </span>
                                            </p>
                                            :
                                            <p className='mb-0 pt-3 e-text-onyx e-font-16 e-alt-font-poppins e-font-weight-400 line-height-28px'>
                                                An OTP has been sent to your registered email.
                                                <span className='ms-1 e-text-egyptian-blue e-font-weight-500'>
                                                    {USER_DATA.email}
                                                </span>
                                            </p>
                                    }
                                    <div className='pt-3'>
                                        <label className="e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px">
                                            Enter your OTP*
                                        </label>
                                        <OTPInput ref={otpInputRef}
                                            id="otp"
                                            value={otpValue}
                                            spellCheck="false"
                                            error={otpError}
                                            focused_input={focusedInput}
                                            onFocus={() => setFocusedInput(2)}
                                            onBlur={() => setFocusedInput(0)}
                                            onChange={_handleChangeOTP} />

                                        <div className='e-inline-flex mt-2'>
                                            <button className={`${timer === 0 ? "text-decoration-hover-underline" : "e-disable"} border-0 e-bg-transparent e-text-egyptian-blue e-font-12 e-alt-font-poppins e-font-weight-500 line-height-26px ps-0`}
                                                // disabled={isResendDisabled}
                                                disabled={disableResendOTP}
                                                onClick={_handleResendOTP} >
                                                Re-send OTP
                                            </button>
                                            {timer !== 0 &&
                                                <p className='mb-0 e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-600 line-height-26px'>
                                                    in {timer} {timer == 1 ? "second" : "seconds"}
                                                </p>
                                            }
                                        </div>
                                    </div>

                                    <p className='mb-0 pt-3 e-text-sonic-silver e-font-12 e-alt-font-poppins e-font-weight-400 line-height-18px'>
                                        *In accordance with regulatory, 2FA verification is required in order to create an order.
                                    </p>
                                </div>

                                <div className='d-flex gap-3 padding-36px-top'>
                                    <SecondaryButton name={"Cancel"}
                                        dismiss="modal"
                                        target=""
                                        className="w-50 padding-12px-tb e-bg-lotion e-font-16 e-text-charleston-green e-border-bright-gray"
                                        onPress={props.onClose} />
                                    <PrimaryButton name={"Confirm"}
                                        loading={loading}
                                        disabled={isDisabled}
                                            className="w-50 e-border-radius-32 padding-12px-top padding-12px-bottom e-primary-button-hover transition"
                                        onPress={_handleNomineeSubmit} />
                                </div>
                            </div>
                        </div>
                    )
                }

            </div>
        </div >
    )
}

export default ManageNomineeModal;